export const exportCSV = (rows, filename) => {
  if (!rows || rows.length === 0) return;
  const headers = Object.keys(rows[0]).join(',');
  const body = rows.map(r =>
    Object.values(r).map(v =>
      typeof v === 'string' && v.includes(',') ? `"${v}"` : v ?? ''
    ).join(',')
  ).join('\n');
  const blob = new Blob([headers + '\n' + body], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};

export const DATE_PRESETS = ['This Week', 'This Month', 'Last Month', 'This Quarter', 'This Year', 'Custom'];

export const getPresetRange = (preset) => {
  const now = new Date();
  const today = now.toISOString().split('T')[0];
  if (preset === 'This Week') {
    const start = new Date(now);
    start.setDate(now.getDate() - now.getDay());
    return { start: start.toISOString().split('T')[0], end: today };
  }
  if (preset === 'This Month') {
    return { start: new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0], end: today };
  }
  if (preset === 'Last Month') {
    const s = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const e = new Date(now.getFullYear(), now.getMonth(), 0);
    return { start: s.toISOString().split('T')[0], end: e.toISOString().split('T')[0] };
  }
  if (preset === 'This Quarter') {
    const q = Math.floor(now.getMonth() / 3);
    const s = new Date(now.getFullYear(), q * 3, 1);
    return { start: s.toISOString().split('T')[0], end: today };
  }
  if (preset === 'This Year') {
    return { start: `${now.getFullYear()}-01-01`, end: today };
  }
  return { start: '', end: today };
};

export const inRange = (dateStr, start, end) => {
  if (!dateStr) return false;
  if (start && dateStr < start) return false;
  if (end && dateStr > end) return false;
  return true;
};

// Attributes a load to the truck unit that actually hauled it. Unit-level
// reports used to group loads by "whichever driver is CURRENTLY assigned
// to this Asset" -- correct only as long as that driver has never been
// reassigned to a different truck since. NewLoadModal/EditLoadModal/
// LoadBoard/AIDispatchChat now snapshot `truck_unit` onto the Load itself
// at booking time (the unit actually in use then), so this prefers that
// ground truth and only falls back to the current-assignment guess for
// older loads booked before that snapshot existed.
export const loadsForUnit = (loads, asset) => loads.filter(l =>
  l.truck_unit
    ? l.truck_unit.toLowerCase() === (asset.unit_number || '').toLowerCase()
    : l.assigned_driver_email && asset.assigned_driver_email &&
      l.assigned_driver_email.toLowerCase() === asset.assigned_driver_email.toLowerCase()
);